/**
 * Utility functions for map-related operations
 */

// Utility: AIS Ship Type mapping

type Range = [number, number];

const shipTypeRanges: Array<[Range, string]> = [
  [[0, 0], 'Not available'],
  [[1, 19], 'Reserved for future use'],
  [[20, 29], 'Wing in ground (WIG)'],
  [[30, 30], 'Fishing'],
  [[31, 32], 'Towing'],
  [[33, 33], 'Dredging or underwater ops'],
  [[34, 34], 'Diving ops'],
  [[35, 35], 'Military ops'],
  [[36, 36], 'Sailing'],
  [[37, 37], 'Pleasure Craft'],
  [[38, 39], 'Reserved'],
  [[40, 49], 'High speed craft (HSC)'],
  [[50, 50], 'Pilot Vessel'],
  [[51, 51], 'Search and Rescue vessel'],
  [[52, 52], 'Tug'],
  [[53, 53], 'Port Tender'],
  [[54, 54], 'Anti-pollution equipment'],
  [[55, 55], 'Law Enforcement'],
  [[56, 57], 'Spare - Local Vessel'],
  [[58, 58], 'Medical Transport'],
  [[59, 59], 'Noncombatant ship according to RR Resolution No. 18'],
  [[60, 69], 'Passenger'],
  [[70, 79], 'Cargo'],
  [[80, 89], 'Tanker'],
  [[90, 99], 'Other Type'],
];

/**
 * Get ship type description from AIS vessel type code
 * @param type - AIS vessel type code (0-99)
 * @returns Human-readable ship type description
 */
export const getShipType = (type: number | string): string => {
  const num = Number(type);
  if (Number.isNaN(num)) return 'Unknown type';

  const match = shipTypeRanges.find(([range]) => num >= range[0] && num <= range[1]);
  return match?.[1] ?? 'Unknown type';
};
